import React from 'react'
import { useParams } from 'react-router-dom'
import { useGetQuizByVideoIdQuery } from '../../features/quiz/quizApi'

export default function Quiz() {
    const { videoId } = useParams()
    const { isSuccess: isSuccessFetchQuizzes, data: quizzes } = useGetQuizByVideoIdQuery(videoId)


    console.log(quizzes)
    function handleChange(e, question) {
        console.log({ question, name: e.target.name, value: e.target.checked })
    }

    function handleQuiz(e) {
        e.preventDefault();

        console.log("kjshkjakj")
    }

    return (
        <section className="py-6 bg-primary rounded-lg">
            <form onSubmit={handleQuiz} className="mx-auto max-w-7xl px-5">
                <div className="mb-8">
                    <h1 className="text-2xl font-bold">Quizzes for "Debounce Function in JavaScript - JavaScript Job Interview question"
                    </h1>
                    <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
                </div>
                <div className="space-y-8">
                    {
                        quizzes?.length > 0 && quizzes?.map((quiz, question) => <div key={quiz.id} className="quiz">
                            <h4 className="question">{quiz.question}</h4>
                            <div className="quizOptions">
                                {
                                    quiz?.options?.map((option) => <label key={option.id} htmlFor={question + 1 + "" + option.id}>
                                        <input onChange={e => handleChange(e, question + 1)} name={question + 1 + "" + option.id} type="checkbox" id={question + 1 + "" + option.id} />
                                        {option.option}
                                    </label>)
                                }
                            </div>
                        </div>)
                    }
                </div>

                <button className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 ">Submit</button>
            </form>
        </section>
    )
}
